import { normalizeApiError } from '../api/apiError';
import { createReadAsyncThunk } from "../store/createReadAsyncThunk";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FamEnrolment } from '../api/endpoints/famEnrolmentApi';
import { ApiRequestStatus } from "../enums/apiRequestStatus";
import { FamEnrolmentYear } from "../models/membership/famEnrolmentYear";

interface famEnrolmentState {
    basketId: string | null;
    famEnrolmentYears: FamEnrolmentYear[] | null;
    basketIdStatus: ApiRequestStatus;
    nextYearBasketIdStatus: ApiRequestStatus;
    enrolmentYearsStatus: ApiRequestStatus;
}

const initialState: famEnrolmentState = {
    basketId: null,
    famEnrolmentYears: null,
    basketIdStatus: ApiRequestStatus.Idle,
    enrolmentYearsStatus: ApiRequestStatus.Idle,
    nextYearBasketIdStatus: ApiRequestStatus.Idle
}

export const basketAsync = createAsyncThunk<string>(
    'famEnrolment/basketAsync',
    async (_, thunkAPI) => {
        try {
            return await FamEnrolment.basketAsync();
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const nextYearEnrolBasketAsync = createAsyncThunk<string>(
    'famEnrolment/NextYearEnrolBasket',
    async (_, thunkAPI) => {
        try {
            return await FamEnrolment.nextYearEnrolBasketAsync();
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const getEnrolmentYearsAsync = createReadAsyncThunk<FamEnrolmentYear[]>(
    'famEnrolment/getEnrolmentYearsAsync',
    async (_, thunkAPI) => {
        try {
            return await FamEnrolment.getEnrolmentYearsAsync();
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const famEnrolmentSlice = createSlice({
    name: 'famEnrolmentSlice',
    initialState,
    reducers: {

    },
    extraReducers: (builder => {
        builder.addCase(basketAsync.pending, (state) => {
            state.basketIdStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(basketAsync.fulfilled, (state, action) => {
            state.basketId = action.payload;
            state.basketIdStatus = ApiRequestStatus.Fulfilled;
        });
        builder.addCase(basketAsync.rejected, (state) => {
            state.basketIdStatus = ApiRequestStatus.Rejected;
        });

        builder.addCase(nextYearEnrolBasketAsync.pending, (state) => {
            state.nextYearBasketIdStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(nextYearEnrolBasketAsync.fulfilled, (state, action) => {
            state.basketId = action.payload;
            state.nextYearBasketIdStatus = ApiRequestStatus.Fulfilled;
        });
        builder.addCase(nextYearEnrolBasketAsync.rejected, (state) => {
            state.nextYearBasketIdStatus = ApiRequestStatus.Rejected;
        });

        builder.addCase(getEnrolmentYearsAsync.pending, (state) => {
            state.enrolmentYearsStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(getEnrolmentYearsAsync.fulfilled, (state, action) => {
            state.famEnrolmentYears = action.payload;
            state.enrolmentYearsStatus = ApiRequestStatus.Fulfilled;
        });
        builder.addCase(getEnrolmentYearsAsync.rejected, (state) => {
            state.enrolmentYearsStatus = ApiRequestStatus.Rejected;
        });
    })
})
